import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";

export default function SearchInput({ value, onChange, placeholder }: { value: string; onChange: (value: string) => void; placeholder: string }) {
  return (
    <label className="group flex h-10 min-w-0 flex-1 items-center gap-2.5 rounded-xl border border-edge bg-surface px-3.5 transition-all focus-within:border-accent focus-within:ring-4 focus-within:ring-accent/10 sm:min-w-[260px]">
      <FontAwesomeIcon icon={faMagnifyingGlass} className="text-[12px] text-label-muted transition-colors group-focus-within:text-accent" />
      <input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="min-w-0 flex-1 bg-transparent font-[Gilroy-Medium] text-[13px] text-heading-color placeholder:text-placeholder focus:outline-none"
      />
      {value ? (
        <button type="button" aria-label="Clear search" onClick={() => onChange("")} className="text-[11px] text-label-muted hover:text-heading-color">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      ) : null}
    </label>
  );
}
